/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {TargetingHelper} from '../targeting-helper';

import template from './third-party-audience-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-third-party-audience-target-summary',
  template
})
export class ThirdPartyAudienceSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any[] = [];
  isComplex = false;
  showOnly = 2;
  quantity = 2;

  ngOnChanges(): void {
    const targets = this.targets || {};
    this.isComplex = TargetingHelper.isComplexThirdPartyAudience(targets);
    this.data = targets;
    this.quantity = this.showOnly;
  }

  switchUp(): void {
    if (this.quantity === this.showOnly) {
      this.quantity = this.data.length;
      return;
    }
    this.quantity = this.showOnly;
  }
}
